import React, { Component } from "react";
import { connect } from "react-redux";

import { RegisterTableContainer } from "./index";
import { RegisterTableHead } from "./head";
import { EmptyRegisterTableBody, ReadOnlyRegisterTableBody } from "./body";
import { TopScrollBar } from "./topScrollBar";


class _ReadOnlyRegisterTable extends Component {

    constructor(props) {
        super(props);
    }

    readOnlyPageCount() {
        return this.props.chunkedReadOnlyRowKeys.length
    }

    totalPageCount() {
        return this.readOnlyPageCount()
    }


    render() {
        const { chunkedReadOnlyRowKeys, pageCount, numTableColumns } = this.props;
        const paginatedRowKeys = [].concat(...chunkedReadOnlyRowKeys.slice(0, pageCount));

        return (
            <div>
                <TopScrollBar />
                <RegisterTableContainer loadMoreConditional={ this.totalPageCount() > pageCount } >

                    <RegisterTableHead />

                    { paginatedRowKeys.length === 0 ?
                        <EmptyRegisterTableBody
                            numTableColumns={numTableColumns}
                        /> :
                        <ReadOnlyRegisterTableBody rowKeys={ paginatedRowKeys } />
                    }

                </RegisterTableContainer>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
    chunkedReadOnlyRowKeys: state.mutablePagination.chunkedReadOnlyRowKeys,
    pageCount: state.mutablePagination.pageCount,
    numTableColumns: state.immutableInterface.numTableColumns,
});

export const ReadOnlyRegisterTable = connect(mapStateToProps)(_ReadOnlyRegisterTable);
